import React from "react";
import { useSelector } from "react-redux";
import { getFullName } from "utils";

const ApplicantDetails = (props) => {
  const { transactionUnderReview } = useSelector(
    (state) => state.transactionSlice
  );
  const { transactions } = transactionUnderReview.items;
  let createdBy = transactions[0].createdBy;
  const fields = [
    {
      name: "fullName",
      key: "Full Name",
      value: getFullName(createdBy?.names),
    },
    {
      name: "phoneNumber",
      key: "Phone Number",
      value: createdBy?.electronicAddress?.mobileNumber,
    },
    {
      name: "phoneNumber",
      key: "Phone Number",
      value: getFullName(createdBy?.names),
    },
    {
      name: "role",
      key: "Role",
      value: "Registrar",
    },
  ];
  return (
    <div>
      <div className="px-4 py-6 bg-white rounded-sm shadow-sm sm:rounded md:rounded-md sm:p-6">
        <div className="flex flex-col space-y-2">
          {fields.map((field, index) => (
            <div key={`${field.key}_${index}`} className="flex flex-col">
              <div className="flex items-baseline justify-between">
                <label
                  htmlFor={field.name}
                  className="block mb-2 text-sm text-primary font-medium min-w-[13rem] w-52 whitespace-normal"
                >
                  {field.key}
                </label>

                <div
                  className={`bg-formInput flex w-[80%] justify-between relative`}
                >
                  {field.value}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ApplicantDetails;
